import comp from "./Element";
export default comp;
